import * as Localization from 'expo-localization';
import i18n from 'i18n-js';
import locale_de from './de';
import locale_en from './en';

// Set the key-value pairs for the different languages you want to support.
i18n.translations = {
  de: locale_de,
  en: locale_en
}
// Set the locale once at the beginning of your app.
i18n.defaultLocale = 'de';
// i18n.locale = Localization.locale
// enforce de as current locale
i18n.locale = 'de'
// When a value is missing from a language it'll fallback to another language with the key present.
i18n.fallbacks = true

export default i18n
